module.exports = __webpack_public_path__ + "media/images/application/template/arrow-down-65b31a185ae5e6d14a561ad5c71cd581.svg";